import * as React from 'react';

import SMSPreviewTooltip from './SMSPreviewTooltip';
import Glyph from 'components/Glyph';
import Link from 'components/Link';

type Props = {
  text: String,
  sms_preview_limit: number,
  composer?: boolean, // toggle the style seen in the Composer vs the Chat
};

const SMSPreviewButton = (props: Props) => (
  <SMSPreviewTooltip text={props.text} data-test="sms-preview-tooltip">
    <Link
      disabled={props.text.length < props.sms_preview_limit}
      color={props.composer ? 'brand' : 'thunder'}>
      {!props.composer && <Glyph name="chat" className="MessageComposer-actionGlyph" />}
      <span>SMS Preview</span>
    </Link>
  </SMSPreviewTooltip>
);

export default SMSPreviewButton;
